(()=>{function init(root){root.querySelectorAll('.wcr').forEach(range=>{if(range.dataset.ready)return;range.dataset.ready='true';const track=range.querySelector('.wcr__track'),buttons=range.querySelectorAll('[data-wcr-step]');const sync=()=>buttons.forEach(b=>b.disabled=Number(b.dataset.wcrStep)<0?track.scrollLeft<=2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2);buttons.forEach(b=>b.addEventListener('click',()=>{const card=track.querySelector('.wcr__card');track.scrollBy({left:Number(b.dataset.wcrStep)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}));track.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(track);sync()})}init(document);document.addEventListener('shopify:section:load',e=>init(e.target))})();
(() => {
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.wcr__form')) return;
    event.preventDefault();
    const button = form.querySelector('[data-wcr-add]');
    if (!button || button.disabled) return;
    const label = button.querySelector('[data-wcr-label]');
    const original = label.textContent;
    const base = window.Shopify?.routes?.root || '/';
    const status = button.closest('.wcr').querySelector('[data-wcr-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = button.dataset.adding;
    let added = false;
    try {
      const response = await fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: form.elements.id.value, quantity: 1})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || button.dataset.error);
      added = true;
      label.textContent = button.dataset.added;
      button.classList.add('is-added');
      if (status) status.textContent = button.dataset.title + ': ' + button.dataset.added;
      try {
        const cartResponse = await fetch(base + 'cart.js', {headers: {Accept: 'application/json'}});
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();
        document.querySelectorAll('[ref="cartBubble"]').forEach(b => b.classList.toggle('visually-hidden', cart.item_count === 0));
        document.querySelectorAll('[ref="cartBubbleCount"]').forEach(c => {c.textContent = cart.item_count; c.classList.toggle('hidden', cart.item_count === 0)});
        document.querySelectorAll('cart-icon').forEach(i => i.classList.toggle('header-actions__cart-icon--has-cart', cart.item_count > 0));
        try { sessionStorage.setItem('cart-count', JSON.stringify({value: String(cart.item_count), timestamp: Date.now()})) } catch {}
        document.dispatchEvent(new CustomEvent('cart:update', {bubbles: true, detail: {resource: cart, data: {itemCount: cart.item_count, source: 'wolds-collection-range'}}}));
      } catch {}
      document.dispatchEvent(new CustomEvent('wolds:cart-changed'));
    } catch (error) {
      label.textContent = button.dataset.error;
      if (status) status.textContent = button.dataset.title + ': ' + (error.message || button.dataset.error);
    } finally {
      button.removeAttribute('aria-busy');
      setTimeout(() => {
        button.disabled = false;
        button.classList.remove('is-added');
        label.textContent = original;
      }, added ? 1400 : 3000);
    }
  });
})();